import blogArticles from './blogArticles.json';
// Blog articles data for the blog page
export interface BlogArticle {
  id: string;
  title_en: string;
  title_fa: string;
  slug: string;
  canonical_url: string;
  summary_en: string;
  summary_fa: string;
  published_date: string;
  reading_time: number;
  author_name: string;
  author_slug: string;
  category: string;
  tags: string[];
  language: string;
  meta_title_en: string;
  meta_description_en: string;
  featured_image: string;
  related_articles: string[];
  is_featured: boolean;
  content_sections?: {
    title: string;
    content: string;
    phrases?: {
      persian: string;
      pronunciation: string;
      english: string;
      context: string;
    }[];
    poetry_examples?: {
      title: string;
      persian: string;
      transliteration: string;
      english: string;
      context: string;
    }[];
    vocabulary_section?: {
      title: string;
      words: {
        persian: string;
        pronunciation: string;
        english: string;
        context: string;
      }[];
    };
    poetry_analysis?: {
      ghazal_title: string;
      lines: {
        persian: string;
        transliteration: string;
        english: string;
        analysis: string;
      }[];
      themes: string;
    };
    cultural_practices?: {
      persian: string;
      pronunciation: string;
      english: string;
      context: string;
    }[];
    reading_tips?: string[];
    language_learning_benefits?: string[];
    dish_details?: {
      persian_name: string;
      pronunciation: string;
      origin: string;
      cooking_time: string;
      difficulty: string;
      flavor_profile: string;
      main_ingredients: string[];
      cultural_significance: string;
    };
  }[];
}

// Blog articles are now loaded from blogArticles.json for easier editing and dynamic updates.
// If you add or edit articles, update client/src/data/blogArticles.json instead.

export default blogArticles as BlogArticle[]; 